// © Microsoft Corporation. All rights reserved.

/**
 * Mediator events
 * @export
 * @type {object}
 */
export const MediatorEventNames = {
    // Event fired when content actions attributes are updated (eg: new video is loaded)
    ContentActionsUpdated: "contentActionsUpdated",
    // Event fired when a feed is successfully followed
    FeedFollowed: "feedFollowed",
    // Event fired when a feed is successfully followed/un-followed to let pre-load
    // framework know it needs to refresh the page
    ForcePageReload: "forcePageReload",
    // Event fired when a feed is successfully followed/un-followed
    FollowedTopicsUpdated: "followedTopicsUpdated",
    // Event to fire to show a specific mediated coach mark
    MediatedCoachMark: "mediated_coach_mark",
    // Event fired by Prime when the tab is being changed
    TabNavigation: "tab_navigation",
    // Event that tells Prime feedsNav module to navigate to the specified URL
    TabNavigateTo: "tab_navigate_to",
    // Event fired when a topic is followed/unfollowed so SPA can re-act
    TopicAction: "topic_action",
    // Event fired when a 360 experience is launched
    Msn360: "msn360",
    // Event to fire to show card action menu
    CardActionInit: "cardActionInit",
    // Event to fire to post card action menu
    CardActionPost: "cardActionPostEvent",
    // Event to fire when interests render complete
    InterestsRenderComplete: "interestsRenderCompleteEvent",
    // Event to fire when an Xfeed needs to load
    RenderXFeed: "show_xfeed_content",
    // Event to fire when a pivot needs to load by id
    ShowPivotById: "show_pivot_by_id",
    // Event that tells Prime infopane module to resume the auto-rotation
    ResumeInfopaneAutoRotate: "resumeInfopaneAutoRotate",
    // Event fired when social actions attributes are updated (eg: new video is loaded)
    SocialActionsUpdated: "socialActionsUpdated"
};